import Inputmask from 'inputmask';

export function snilsMask() {
  const $snils = $('.snils-mask');
  if (!$snils || $snils.length === 0) return;

  new Inputmask({
    mask: '999-999-999 99',
  }).mask('.snils-mask');
}
